import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './circleButton.module.css'

type ButtonAnchorHTMLAttributes = React.ButtonHTMLAttributes<
  HTMLButtonElement
> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

const CircleButton = ({
  className,
  children,
  ...nextProps
}: ButtonAnchorHTMLAttributes) => {
  const Tag = nextProps.href ? 'a' : 'button'
  const nextClassName = classnames(styles.root, className)

  return (
    <Tag className={nextClassName} {...nextProps}>
      {children}
    </Tag>
  )
}

export default CircleButton
